const QUICK_EXPORT_ONLY_KEYS = ["type", "report_id"] as const;

export function toReportRunParams(params: Record<string, unknown>): Record<string, unknown> {
  const runParams = { ...params };

  QUICK_EXPORT_ONLY_KEYS.forEach(key => {
    delete runParams[key];
  });

  return runParams;
}
